<template>
    <div class="apprentice-simple-card remove-bottom-card-margin group-show-tools-calendar">
        <b-button
            class="btn-add btn-add-calendar-item"
            v-b-modal="'create-agenda-item-modal'"
            variant="primary">
            {{ $t('group.new_appointment') }}
        </b-button>

        <design-2021-group-show-add-agenda-item-modal-component @create-agenda-item="addAgendaItem($event)">
        </design-2021-group-show-add-agenda-item-modal-component>

        <design-2021-group-show-edit-agenda-item-modal-component
            :ref="'edit-agenda-item-modal'"
            @update-agenda-item="updateAgendaItem($event)">
        </design-2021-group-show-edit-agenda-item-modal-component>

        <design-2021-group-calendar-settings-modal-component
            :ref="'settings-agenda-item-modal'"
            @update-item="openEditModal()"
            @delete-item="removeAgendaItem()"
            :item-in="selectedItem"
            :is-group-admin="isGroupAdmin"
            :group-id-in="groupId">
        </design-2021-group-calendar-settings-modal-component>

        <design-2021-apprentice-fullcalendar-component
            :calendar-items-in="agendaItems"
            ref="groupCalendar"
            :types="['listYear', 'dayGridWeek', 'dayGridMonth']"
            :right-buttons="true"
            :emit-changed-date="true"
            @update-item="settingsModal($event)"
            @change-date="changeDate($event)"></design-2021-apprentice-fullcalendar-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-calendar-component',
    props: {
        groupId: Number,
        agendaItemsIn: Array,
        isStudent: Boolean,
        isGroupAdmin: Boolean,
    },
    data() {
        return {
            agendaItems: this.agendaItemsIn.map((item) => {
                let color = '';

                switch (item.type_id) {
                    // 1 = logboek
                    case 1:
                        color = 'blue';
                        break;
                    // 2 = planning
                    case 2:
                        color = 'orange';
                        break;
                    // 3 = deadline
                    case 3:
                        color = 'red';
                        break;
                    default:
                        color = 'orange';
                }

                let start;
                let end = null;

                if (item.time) {
                    start = item.date_time;
                } else {
                    start = item.date;
                }
                if (item.date_time_end_date) {
                    end = item.date_time_end_date;
                } else {
                    end = start;
                }

                let hasRoadmap = false;

                if (item.model_type === 'App\\Models\\Roadmap\\RoadmapStep') {
                    hasRoadmap = true;
                }

                return {
                    id: item.id,
                    title: item.title,
                    date: item.date,
                    created_by: item.created_by,
                    date_end: item.date_end,
                    date_time: item.date_time,
                    date_time_end_date: item.date_time_end_date,
                    description: item.description,
                    location: item.location,
                    time: item.time,
                    time_end: item.time_end,
                    color: color,
                    start: start,
                    end: end,
                    model_type: item.model_type,
                    model_id: item.model_id,
                    roadmap: hasRoadmap,
                };
            }),
            selectedItem: {},
            localStorageName: `group-calendar-view-${this.groupId}${this.$authUser.id}`,
            init: true,
        };
    },
    methods: {
        addAgendaItem(values) {
            this.alert.saving();
            const data = {
                title: values.title,
                description: values.description,
                location: values.location,
                date: values.startDate,
                time: values.startTime,
                end_date: values.endDate,
                end_time: values.endTime,
                agenda_type: 'group',
            };
            this.axios.post(this.routes.groupAgendaCreate(this.groupId), data).then(
                (response) => {
                    let color = '';

                    switch (response.data.type_id) {
                        // 1 = logboek
                        case 1:
                            color = 'blue';
                            break;
                        // 2 = planning
                        case 2:
                            color = 'orange';
                            break;
                        // 3 = deadline
                        case 3:
                            color = 'red';
                            break;
                        default:
                            color = 'orange';
                    }

                    response.data.agenda_item.color = color;
                    response.data.agenda_item.start = response.data.agenda_item.date_time;
                    response.data.agenda_item.end =
                        response.data.agenda_item.date_end + ' ' + response.data.agenda_item.time_end;

                    this.agendaItems.push(response.data.agenda_item);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        settingsModal(item) {
            this.agendaItems.forEach((calendarItem) => {
                if (calendarItem.id === Number(item.id)) {
                    this.selectedItem = calendarItem;
                }
            });

            this.$refs['settings-agenda-item-modal'].show();
        },
        openEditModal() {
            this.$refs['edit-agenda-item-modal'].show(this.selectedItem);
        },
        updateAgendaItem(values) {
            this.alert.saving();

            const data = {
                title: values.title,
                description: values.description,
                location: values.location,
                date: values.startDate,
                time: values.startTime,
                end_date: values.endDate,
                end_time: values.endTime,
                agenda_type: 'group',
            };

            this.axios.post(this.routes.groupAgendaUpdate(this.groupId, values.id), data).then(
                (response) => {
                    response.data.agenda_item.start = response.data.agenda_item.date_time;
                    response.data.agenda_item.end =
                        response.data.agenda_item.date_end + ' ' + response.data.agenda_item.time_end;
                    this.agendaItems = this.agendaItems.map((item) =>
                        item.id === values.id ? response.data.agenda_item : item,
                    );
                    this.alert.success();

                    this.agendaItems.forEach((calendarItem) => {
                        if (calendarItem.id === Number(values.id)) {
                            this.selectedItem = calendarItem;
                        }
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        removeAgendaItem() {
            this.alert
                .confirm(
                    this.$t('group.delete_appointment_confirmation_title'),
                    this.$t('group.delete_appointment_confirmation_body'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.groupAgendaRemove(this.groupId, this.selectedItem.id)).then(
                            (response) => {
                                this.agendaItems = this.agendaItems.filter((item) => item.id !== this.selectedItem.id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        changeDate(data) {
            if (this.init) {
                if (localStorage.getItem(this.localStorageName) && this.init) {
                    this.$refs.groupCalendar.$refs.fullCalendar.calendar.changeView(
                        localStorage.getItem(this.localStorageName),
                    );
                    this.init = false;
                }
            }

            localStorage.setItem(this.localStorageName, data.view);
        },
    },

    mounted() {
        this.$nextTick(() => {
            if (
                localStorage.getItem(this.localStorageName) &&
                this.localStorageName === `group-calendar-view-${this.groupId}${this.$authUser.id}`
            ) {
                this.$refs.groupCalendar.$refs.fullCalendar.calendar.changeView(
                    localStorage.getItem(this.localStorageName),
                );
            }
        });
    },
};
</script>

<style scoped lang="scss">
.new-appointment {
    display: flex;
    justify-content: flex-end;
}

.new-appointment,
.month-view {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.monthly-items {
    height: 100%;
    min-height: 300px;
}

.appointment-item {
    position: relative;

    .appointment-item-management {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;

        .btn {
            &:before {
                margin-right: 0;
            }

            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    &:hover {
        cursor: pointer;

        .appointment-item-management {
            opacity: 1;
        }
    }

    &:not(:first-child) {
        .appointment-item-management {
            top: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.calendar-month-view {
    text-align: center;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .calendar-month-view {
        text-align: center;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .month-view {
        margin-bottom: 0;
    }
}
</style>
